'use strict';
module.exports = require('./ColorPicker.vue');